import React from "react";
import PropTypes from "prop-types";

import App from "apps/notifications_footer/components/App";
import useIsWhitelistedNotificationRoute from "apps/notifications_footer/util/useIsWhitelistedNotificationRoute";

const NotificationsFooter = ({ userid }) => {
	const showNotificationsFooter = useIsWhitelistedNotificationRoute();

	// Exit if no show.
	if (!showNotificationsFooter) {
		return null;
	}

	return (
		<App userid={userid} />
	);
};

NotificationsFooter.propTypes = {
	userid: PropTypes.string.isRequired,
};

export default NotificationsFooter;



// WEBPACK FOOTER //
// ./src/apps/notifications_footer/index.js